/* eslint-disable max-lines */

export const config = {
    name: 'assetHandover-allocationDetails',
    selection: true,
    index: false,
    searchFields: [
        {
            name: '客户名称',
            value: 'customerName',
            type: 'advance',
            isFixed: true,
            span: 5,
            advanceConfig: [
                { prop: 'customerName', value: '客户名称' },
                { prop: 'customerCode', value: '客户编码' },
                { prop: 'customerGroupName', value: '客户系名称' }
            ],
            tableConfig: [
                { prop: 'customerCode', value: '客户编码' },
                { prop: 'customerName', value: '客户名称' },
                { prop: 'customerGroupName', value: '客户系名称' }
            ],
            prefix: '/api-lcrm',
            method: 'post',
            advanceUrl: '/customer/info/page',
            cbParams: ['customerCode', 'customerName#customerName'],
            advanceCode: 'advanceCode',
            beforeRequest: (params) => {
                // params.customerStatus = '1';
                return params;
            }
        },
        {
            name: '分公司',
            value: 'companyName',
            type: 'advanceMulti',
            isFixed: true,
            span: 5,
            advanceConfig: [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            tableConfig: [
                { 'prop': 'companyCode', 'value': '分公司编码' },
                { 'prop': 'companyNameCn', 'value': '分公司名称', 'displayName': 'companyNameCn' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/esCompany/popCompany`,
            cbParams: ['companyCode', 'companyNameCn#companyName']
        },
        {
            name: '经营中心',
            value: 'businessCenterName',
            type: 'advanceMulti',
            isFixed: true,
            span: 5,
            advanceConfig: [
                { prop: 'businessCenterName', value: '经营中心名称' },
                { prop: 'businessCenterCode', value: '经营中心编码' }
            ],
            tableConfig: [
                { prop: 'businessCenterName', value: '经营中心名称', displayName: 'businessCenterName' },
                { prop: 'businessCenterCode', value: '经营中心编码' }
            ],
            prefix: '/api-lcs',
            advanceUrl: '/bid/queryCompanyByCodeAndName',
            cbParams: ['businessCenterCode', 'businessCenterName'],
            advanceCascade: 'companyCode#companyCode' // 关联入参只针对单选有效
        },
        {
            name: '分摊类型',
            value: 'respDivideList',
            type: 'select',
            optionNum: 'NEOCRM_RESP_DIVIDE',
            isFixed: true,
            multiple: true,
            span: 5
        },
        {
            name: '维护状态',
            value: 'maintainStatusList',
            type: 'select',
            isFixed: true,
            multiple: true,
            optionNum: 'MANAGER_ARCHIVE_MAINTAIN_STATUS',
            span: 5
        },
        // {
        //     name: '变更单流程状态',
        //     value: 'mipStatusList',
        //     type: 'select',
        //     isFixed: true,
        //     multiple: true,
        //     optionNum: 'SYS_SU_MIP_AUDIT_STATUS',
        //     span: 5
        // },
        {
            name: '异常数据',
            value: 'ruleStatus',
            type: 'select',
            isFixed: true,
            multiple: true,
            optionNum: 'MONITOR_STATUS',
            span: 5
        }
    ],
    columns: [
        {
            label: '单据号',
            prop: 'commissionId',
            width: 100
        },
        {
            label: '客户编码',
            prop: 'customerCode',
            width: 150
        },
        {
            label: '客户名称',
            prop: 'customerName',
            width: 200
        },
        {
            label: '分公司',
            prop: 'companyName',
            width: 150
        },
        {
            label: '经营中心',
            width: 150,
            prop: 'businessCenterName'
        },
        {
            label: '行业大类',
            width: 120,
            prop: 'industryCategoriesCode',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'SYS_SUPPLIER_INDUSTRY'
        },
        {
            label: '行业类型',
            optionsKey: 'SYS_INDUSTRY_TYPE',
            width: 100,
            type: 'slot',
            slot: true,
            editSlot: true,
            prop: 'industryType'
        },
        {
            label: '分摊类型',
            width: 120,
            prop: 'respDivide',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'NEOCRM_RESP_DIVIDE'
        },
        {
            label: '客户经理',
            width: 110,
            prop: 'customerOwnerName'
        },
        {
            label: '单据所在部门',
            width: 150,
            prop: 'billDepartmentName'
        },
        {
            label: '单据来源类型',
            width: 150,
            prop: 'billSource',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'MANAGER_BILL_SOURCE_REMARK'
        },
        {
            label: '生效日期',
            width: 160,
            prop: 'effectStartTime'
        },
        {
            label: '失效日期',
            width: 160,
            prop: 'effectEndTime'
        },
        {
            label: '维护状态',
            width: 110,
            prop: 'maintainStatus',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'MANAGER_ARCHIVE_MAINTAIN_STATUS'
        },
        {
            label: '异常数据',
            width: 160,
            prop: 'ruleStatus',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'MONITOR_STATUS'
        },
        {
            label: '异常原因',
            width: 160,
            prop: 'errorMsg'
        },
        {
            label: '承接人',
            prop: 'receiverName',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 100,
            fixed: 'right'
        }
    ]
};
